import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from "vuex-persist";
// import auth from '@/store/auth';
import cNotifications from "@/store/cNotifications";
import keycloak from "@/store/keycloak";
import checkFilled from "@/store/checkFilled";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  // reducer: (state) => ({
  //   auth: state.auth,
  // }),
});
export default new Vuex.Store({
  modules: {
    // auth: auth,
    notifications: cNotifications,
    keycloak: keycloak,
    checkFilled: checkFilled,
  },
  plugins: [vuexLocal.plugin]
})